import Rest from './rest';

const RESOURCE = "category";

export default {
    getList: function () {
        return Rest.get(`${RESOURCE}/list`);
    }
};



// WEBPACK FOOTER //
// ./src/services/CategoryService.js